import { TableCell, TableRow, Typography } from '@mui/material';
import ReusableTable from '../../../components/reusableTable';

const Universities = (props:any) => {
  const columns = [
    {
      name:"University / Course name",
      minWidth:170
    },   {
      name:"State",
      minWidth:170
    },   {
      name:"Country",
      minWidth:170
    },   {
      name:"Course level",
      minWidth:170
    },   {
      name:"Duration",
      minWidth:170
    },
  ]

  const StudentsData = () =>{
    return (
      <>
              {
              props?.data?.length > 0 ? 
              props.data?.map((student: any) => (
                <TableRow
                  key={student._id}
                  sx={{
                    "& .MuiTableCell-root": {
                      padding: "8px",
                      borderRightStyle: "solid",
                      borderRightColor: "gray",
                      borderWidth: "1px",
                    },
                  }}
                  // onClick={() =>
                  //   window.open(`/student/${student.profile._id}/universities`, "_blank")
                  // }
                >
                  <TableCell>
                  <div style={{color:"#FEB853",fontWeight:600,display:"flex",gap:"10px"}}>
                      <img src={student.university.logoSrc} alt="logo" style={{width:"1.5rem",borderRadius:"5px"}}/>{student.university.name}</div>
                    <div style={{fontWeight:500}}>{student?.name}</div>
                  </TableCell>
                  <TableCell>
                  <div style={{fontWeight:500}}>{student?.university?.location?.state}</div>
                  </TableCell>
                  <TableCell>
                  <div style={{fontWeight:500}}>{student?.university?.location?.country}</div>
                  
                  </TableCell>
                  <TableCell>
                  <div style={{fontWeight:500}}>{student?.studyLevel}</div>
                   
                  </TableCell>
                  
                  <TableCell>
                  <div style={{fontWeight:500}}>{} months</div>
                   
                  </TableCell>
                </TableRow>
              ))
             : 
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell colSpan={6}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography align="center">
                        No data available
                      </Typography>
                    </div>
                  </TableCell>
                </TableRow>
             }
      </>
    )
  }
  return (
    <div>
      <ReusableTable
        columns={columns}
        data={<StudentsData/>}
        rowOnClick={undefined}
      />
    </div>
  )
}

export default Universities;